invHdApp.controller('PlateController', ['$scope', 'Plate', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, Plate, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];

    $scope.all = function () {
      Plate.all().success(function (data, status, headers, config) {
        $scope.data = data;
      });
    }

    $scope.openDetail = function (item) {
      Plate.get(item.id).success(function (data, status, headers, config) {
        $('#plateModal').modal('show');
        $scope.plate = data.plate;
      });
    }

    $scope.$on('new_data', function () {
      $('#plateModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      Plate.new().success(function (data, status, headers, config) {
        $scope.plate = {
          'status': 'active'
        };
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Plate.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post($scope.translate(data.message.toString()));
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.plates.indexOf($filter('filter')($scope.data.plates, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1) {
              $scope.data.plates.splice(index, 1);
            }
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.plate.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      Plate.save($scope.plate).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#plateModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      Plate.update($scope.plate).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#plateModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

  }
]);